import { render } from "./ClaimLookup.vue?vue&type=template&id=09ba61bc"
import script from "./ClaimLookup.vue?vue&type=script&lang=js"
export * from "./ClaimLookup.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__